import { render, staticRenderFns } from "./ProjectMilestoneNewForm.vue?vue&type=template&id=8a09f4b8"
import script from "./ProjectMilestoneNewForm.vue?vue&type=script&lang=js"
export * from "./ProjectMilestoneNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports